export const saveTrimmedString = (event: React.ClipboardEvent<HTMLSpanElement>) => {
    const eventTarget = event.target as HTMLElement;
    event.clipboardData.setData(
        'text/plain',
        String(eventTarget.innerText.trim()),
    );
    event.preventDefault();
};
